export default __webpack_public_path__ + "static/media/phone.07a96abf.png";